export enum OrbitOneGalleryContext {
  Lice = 'lice',
  Welfare = 'welfare',
}
